import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { flashSaleType } from "../../types/flashsale";

interface prop {
  products: requestType<flashSaleType>;
}
const initialState: prop = {
  products: { loading: true },
};
export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    getProducts(state, action: PayloadAction<flashSaleType>) {
      state.products.data = action.payload;
      state.products.loading = false;
    },
    setProductsLoading(state, action: PayloadAction<boolean>) {
      state.products.loading = action.payload;
    },
  },
});
export const productAction = productSlice.actions;
export default productSlice.reducer;
